import StudentLogin from "../pages/StudentPortal/StudentLogin";
import StudentRegistration from "../pages/StudentPortal/StudentRegistration";
import AdminLogin from "../pages/DashBoard/AdminLogin";
import NotFound from "../pages/NotFound/NotFound";

const publicRouteComponent = [
  {
    path: "/",
    component: <StudentLogin />,
  },
  {
    path: "/StudentReistration",
    component: <StudentRegistration />,
  },
];

export const publicRouteComponentAdmin = [
  {
    path: "/admin",
    component: <AdminLogin />,
  },
  {
    path: "/*",
    component: <NotFound />,
  },
];

export default publicRouteComponent;
